export default __webpack_public_path__ + "static/media/kotlin-r-bg.8f82e8a2.png";